import { MedRecSwitch, SearchHeader, StoreLocator } from '@/components';
import { PAGE_ROUTES } from '@/constants';

import {
  HeaderBurgerNav,
  HeaderContainer,
  HeaderFavorites,
  HeaderLogo,
  HeaderNav,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../Header.components';

import styles from './HeaderDefault.module.scss';

const HeaderDefault = () => (
  <>
    <HeaderDefaultMobile />
    <HeaderDefaultDesktop />
  </>
);

const HeaderDefaultMobile = () => (
  <HeaderContainer.Mobile>
    <HeaderRow borderless type="small">
      <HeaderSection justify="start">
        <HeaderBurgerNav />
        <HeaderLogo fullWidth />
      </HeaderSection>
      <HeaderSection justify="end">
        <HeaderShopping />
        <HeaderFavorites />
        <HeaderProfile />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow borderless type="flat">
      <HeaderSection justify="center">
        <SearchHeader seeAllHref={PAGE_ROUTES.SHOP} />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow type="small">
      <HeaderSection justify="center" spaceBetweenOnMultipleChildren>
        <StoreLocator />
        <MedRecSwitch />
      </HeaderSection>
    </HeaderRow>
  </HeaderContainer.Mobile>
);

const HeaderDefaultDesktop = () => (
  <HeaderContainer.Desktop>
    <HeaderRow type="medium">
      <HeaderSection justify="start">
        <HeaderLogo />
        <StoreLocator />
        <MedRecSwitch />
      </HeaderSection>
      <HeaderSection justify="end">
        <SearchHeader
          className={styles.search__header}
          seeAllHref={PAGE_ROUTES.SHOP}
        />
        <HeaderShopping />
        <HeaderFavorites />
        <HeaderProfile />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow type="flat" withNavbar>
      <HeaderSection justify="start">
        <HeaderNav />
      </HeaderSection>
    </HeaderRow>
  </HeaderContainer.Desktop>
);

export { HeaderDefault };
